<template>
  <v-row class="conversation-message pb-3" :class="{ 'flex-row-reverse': isCustomerMessage }">
    <div class="avatar-container">
      <EcsAvatar v-if="message.Originator" :name="message.Originator" :size="32" />
    </div>
    <div class="body-container">
      <div class="message-text" :class="{ 'customer-message': isCustomerMessage }">
        <span>{{ message.Content }}</span>
      </div>
    </div>
  </v-row>
</template>

<script>
import EcsAvatar from '@/components/ecs-avatar/EcsAvatar';

export default {
  name: 'EcsMessage',
  components: {
    EcsAvatar
  },
  props: {
    message: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isCustomerMessage() {
      return this.message.IconType === 'me';
    }
  }
};
</script>

<style scoped>
.avatar-container {
  margin: 0 8px;
}
.conversation-message {
  display: flex;
  transition: all 0.5s ease;
  margin: -4px !important;
}
.body-container {
  flex-direction: column;
  display: flex;
}
.conversation-message .message-text {
  padding: 8px 12px;
  border-radius: 4px;
  box-shadow: 1px 1px 3px #0005;
  max-width: 304px;
  width: fit-content;
  background-color: var(--v-custom-surface-lighten1);
  opacity: 0.9;
  transition: all 0.3s ease;
}
.customer-message {
  background-color: var(--v-custom-secondary-base) !important;
  color: #fff;
  align-self: flex-end;
}
.sent-date {
  font-size: 10px;
  white-space: nowrap;
  opacity: 0;
  padding: 4px 0 0 0;
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.customer-sent-date {
  align-self: flex-end;
}
</style>
